<script>
  import { format } from 'svelte-i18n';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import File from './file.svelte';
  import FolderName from './name.svelte';

  export let expanded = true;
  export let name = 'shadowroot';
  export let id = 'shadowroot';
  export let parent = 'shadowroot';
  export let files = [];
  export let editable = false;
  export let selectable = false;
  export let selected = [];
  export let renaming = false;
  export let onSelect = () => {};
  export let onAdd = () => {};
  export let onRename = () => {};
  export let onDelete = () => {};

  const toggle = () => {
    if (renaming) {
      return;
    }

    expanded = !expanded;
  };

  const onAddFolder = () => onAdd({ id, name, parent, files });

  const onRenameFolder = () => {
    renaming = true;
  };

  const onNameChange = () => {
    renaming = false;
    onRename({ id, name, parent, files });
  };

  const onDeleteFolder = () => onDelete({ id, name, parent, files });
</script>

{#if id !== 'shadowroot'}
  <span class="folder" class:subfolders={files.length}>
    {#if selectable}
      <input
        type="checkbox"
        checked={selected.includes(id)}
        on:change={(e) => onSelect(e, { id, name, parent, files })}
      />
    {/if}
    {#if files.length}
      <span class="folder" role="button" class:expanded on:click={toggle} tabindex="0">
        <i class={expanded ? 'os-icon-folder-minus' : 'os-icon-folder-plus'} />
        <div><FolderName bind:renaming bind:name onChange={onNameChange} /></div>
      </span>
    {:else}
      <span class="folder">
        <Icon name="folder" />
        <div><FolderName bind:renaming bind:name onChange={onNameChange} /></div>
      </span>
    {/if}
    {#if editable}
      <Dropdown tag="span" class="folder-actions">
        <DropdownToggle color="secondary" tag="span">
          <Icon name="more-vertical" class="position-absolute d-block" style="bottom: -4px" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem on:click={onAddFolder}>{$format('label.ADD_FOLDER')}</DropdownItem>
          <DropdownItem divider />
          <DropdownItem on:click={onRenameFolder}>{$format('label.RENAME_FOLDER')}</DropdownItem>
          {#if parent !== 'shadowroot'}
            <DropdownItem divider />
            <DropdownItem on:click={onDeleteFolder}>{$format('label.DELETE_FOLDER')}</DropdownItem>
          {/if}
        </DropdownMenu>
      </Dropdown>
    {/if}
  </span>
{/if}

{#if expanded}
  <ul class:selectable>
    {#each files as file}
      {#if file.name}
        <li>
          {#if file.files}
            <svelte:self
              {...file}
              {onAdd}
              {onRename}
              {onDelete}
              {onSelect}
              {selected}
              {selectable}
              {editable}
              {expanded}
            />
          {:else}
            <label for="input-{file.id}">
              {#if selectable}
                <input
                  id="input-{file.id}"
                  type="checkbox"
                  checked={selected.includes(file.id)}
                  on:change={(e) => onSelect(e, file)}
                />
              {/if}
              <File {...file} />
            </label>
          {/if}
        </li>
      {/if}
    {/each}
  </ul>
{/if}

<style lang="scss" src="./folder.scss"></style>
